import { DecimalPipe } from '@angular/common';
import { Component, forwardRef, signal } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-display-decimal',
  imports: [DecimalPipe],
  templateUrl: './display-decimal.component.html',
  styleUrl: './display-decimal.component.css',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DisplayDecimalComponent),
      multi: true,
    },
  ],
})
export class DisplayDecimalComponent implements ControlValueAccessor {
  valueSignal = signal<number | undefined>(undefined);
  isDisabled = false;

  private onChange: any = () => {
    console.log('onChange');
  };
  private onTouch: any = () => {
    console.log('onTouch');
  };

  writeValue(value: number): void {
    this.valueSignal.set(value); // Update the signal when the value changes
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  onValueChange(newValue: number): void {
    this.valueSignal.set(newValue);
    this.onChange(newValue);
    this.onTouch();
  }
}
